var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M36.93 12.481a1.5 1.5 0 01.247 2.107L21.498 34.425a3.645 3.645 0 01-.847.795l-.006.005a3.599 3.599 0 01-4.98-.972l-4.891-6.941a1.5 1.5 0 012.452-1.728l4.9 6.954.02.03a.599.599 0 00.974.028l.017-.022 15.686-19.846a1.5 1.5 0 012.107-.247z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21S35.598 3 24 3zM0 24C0 10.746 10.746 0 24 0s24 10.746 24 24-10.746 24-24 24S0 37.254 0 24z","key":1})]);
}

Success.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = Success;

Success.default = Success;
